const instructionsDataInitial = [
    {
        id: "marinate-chicken",
        name: "Marinate chicken",
        steps: [
            { text: "Slice #chicken thighs# in 1 inch pieces" },
            { 
                text: `Place in a bowl and marinate in #milk# for 30 minutes`,
                timer: 30
            },
            { text: "Pour out the milk, rinse the chicken with water, and pat dry" },
            { text: "Make the marinade by mixing #gochugaru#, #gochujang#, #honey#, #soy sauce#, #sugar#, #minced garlic#, #minced onion#, #minced ginger#, #black pepper#, and #curry powder#. Tip: blend or place garlic, onion, and ginger in a food processor to make things quicker." },
            { 
                text: "Place the chicken in a bowl with the marinade. Mix together, cover, and refridgerate for 30 minutes (or up to 2 days).",
                timer: 30 
            },
        ]
    },
    {
        id: "stir-fry",
        name: "Stir-fry",
        steps: [
            { text: "Slice all veggies: #cabbage#, #white onion#, #sweet potato#, #green onions# and #perilla leaves#. It's important to do this before you start the stir fry." },
            { text: "Heat large pan on medium-high. Once the pan is hot, add #oil#." },
            { text: "Place *chicken* in the center, and add *cabbage*, *onion*, *sweet potatoes*, and #rice cakes#. Cook for 2-3 minutes, then stir everything together. Turn heat to medium and cook for 5 more minutes (should be a high-ish, steady simmer)." },
            { text: "Add #water# and stir again. Cook for 3-4 minutes until sweet potatoes are soft." },
            { text: "Make a well in the center, and put the #shredded mozzarella# into it. Cover pan and cook for 3 minutes or until cheese has melted." },
            { text: "Optionally garnish with dried parsley or basil" }
        ]
    }
]

function importAll(r) {
  return r.keys().map(r);
}

const allMedia = importAll(require.context('./media/instructions', true, /\.(png|jpe?g|gif|webp|mp4|mov|avi|webm|mkv|flv|wmv|m4v|mpeg|mpg|svg)$/));
  
const mediaBySection = allMedia.reduce((acc, path) => {
    const sectionId = path.split('_')[0].split('/').pop(); // Extract section id from path
    if (!acc[sectionId]) { acc[sectionId] = [] } // Initialize array if it doesn't exist
    acc[sectionId].push(path); // Add path to array
    return acc;
}, {});

export const instructions = instructionsDataInitial.map(section => {
    // if there's an array of media for the given section
    if (mediaBySection[section.id]) {
        // add media array
        return { ...section, media: mediaBySection[section.id] };
    } else {
        return section;
    }
})